import { runtimeConfig } from "@src/runtime-config";
import { EmailUtils, RuntimeUtils } from "@stellar/utils";
/**
 * Determines whether an user is authenticated based on the logged in user email.
 * It needs to have a defined id and email.
 */
export function isAuthenticatedUser(loggedInUser) {
  return !!loggedInUser && !!loggedInUser.id && !!loggedInUser.email;
}

/**
 * Checks whether the Amplitude production key should be used
 * based on the environment and user email
 */
export function shouldUseProductionAmplitude({
  appEnv = runtimeConfig.appEnv,
  loggedInUser
}) {
  return (
    // To use the production key, it has to be running in production
    RuntimeUtils.isProductionEnvironment(appEnv) &&
    // The user must be defined and authenticated
    isAuthenticatedUser(loggedInUser) &&
    // The user must not be an internal (FARO) user
    !EmailUtils.isInternalUser(loggedInUser.email)
  );
}

/**
 * Gets the amplitude key(s) to be used based on the user and environment
 *
 * @returns Either an array of amplitude keys to be used or an empty array if amplitude should not be enabled.
 */
export function getAmplitudeKeys({
  loggedInUser,
  appEnv = runtimeConfig.appEnv
}) {
  // If we should use production amplitude means that
  // - The user is authenticated
  // - The user is not internal
  // - The app is running in production
  // In that case, we track in the amplitude projects "XG Platform - Externals PROD" and "Sphere Dashboard (Prod)"
  if (shouldUseProductionAmplitude({
    loggedInUser,
    appEnv
  })) {
    return [runtimeConfig.features.amplitudeKeyProd, runtimeConfig.features.amplitudeKeyOldProd];
  }

  // For everything else use the projects
  // "XG Platform - Internal & Testing" and "Sphere Dashboard (Stg)"
  return [runtimeConfig.features.amplitudeKeyInternal, runtimeConfig.features.amplitudeKeyOldInternal];
}